export default function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="about-wrap">
          <div className="about-img">
            <i className="fa-solid fa-mortar-pestle" />
          </div>
          <div className="about-text">
            <span className="eyebrow">Why natural</span>
            <h2 style={{ fontSize: "2.2rem", margin: ".3rem 0 1rem" }}>Wellness, the way nature intended</h2>
            <p>
              At Green World Nature Pride Healthcare, we believe true health begins with what nature provides. Our
              supplements are formulated from carefully selected herbs and natural ingredients to support your body's own
              ability to heal and thrive.
            </p>
            <p>
              Whether you're managing a long-term concern or simply investing in everyday wellness, we're here to guide
              you to the right natural solution.
            </p>
            <div className="feature-row">
              <div className="feature">
                <i className="fa-solid fa-leaf" />
                <div>
                  <b>Herbal-based</b>
                  <span>Rooted in natural ingredients</span>
                </div>
              </div>
              <div className="feature">
                <i className="fa-solid fa-user-doctor" />
                <div>
                  <b>Guided choice</b>
                  <span>Find what fits your concern</span>
                </div>
              </div>
              <div className="feature">
                <i className="fa-solid fa-truck-fast" />
                <div>
                  <b>Countrywide delivery</b>
                  <span>Across Kenya</span>
                </div>
              </div>
              <div className="feature">
                <i className="fa-brands fa-whatsapp" />
                <div>
                  <b>Easy ordering</b>
                  <span>Order directly via WhatsApp</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
